export default "__VITE_ASSET__39dd1a78__"